export const localServicesMock = {
  golfCtaLabel: 'Reserve Tee Time',
  cardsCount: 0,
  imageQueryParamsAmenities: [
    {
      viewPortName: 'min-width: 1200px',
      retinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
      nonRetinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=400px:*',
    },
    {
      viewPortName: 'min-width: 992px',
      retinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
      nonRetinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=400px:*',
    },
    {
      viewPortName: 'min-width: 576px',
      retinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
      nonRetinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=400px:*',
    },
    {
      viewPortName: 'max-width: 576px',
      retinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
      nonRetinaDisplayParams: 'output-quality=70&interpolation=progressive-bilinear&downsize=400px:*',
    },
  ],
  trackingProperties: {
    additionalTrackingVariables: '',
    enableScrollingBehavior: false,
    trackingDescription: '',
    impressionTrack: false,
    trackingContentPosition: '',
    atCCeVar48: '',
    rightArrowDesc: '',
    leftArrowDesc: '',
    clickTrack: true,
    location: '',
    merchandisingCategory: 'nonCobrand',
    impressionCount: false,
    trackingOfferType: '',
    trackingTag: '',
  },
  diningReservationsCard: [],
  diningFallbackImage: {
    altText: 'mc-dining-0001-hor-clsc',
    assetPath:
      'https://cache.marriott.com/content/dam/marriott-digital/mc/global-property-shared/en_us/photo/other/under-review/assets/mc-dining-0001-hor-clsc.jpg',
    enableSmartCrop: true,
    dynamic: false,
    renditions: [
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '1200px',
        width: 400,
        dynamic: false,
        damPath: 'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-wide.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '992px',
        width: 400,
        dynamic: false,
        damPath: 'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-wide.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-clsc.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-clsc.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '577px',
        width: 400,
        dynamic: false,
        damPath: 'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-hor-clsc.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '576px',
        width: 400,
        dynamic: false,
        damPath: 'https://cache.marriott.com/content/dam/marriott-renditions/MC/mc-dining-0001-sq.jpg',
        mediaQuery: 'max-width',
        height: 0,
      },
    ],
    damPath:
      '/content/dam/marriott-digital/mc/global-property-shared/en_us/photo/other/under-review/assets/mc-dining-0001-hor-clsc.jpg',
  },
  spaFallbackImage: {
    altText: 'dohwh-coolcorner-floorplan-5121',
    assetPath:
      'https://cache.marriott.com/content/dam/marriott-digital/wh/emea/hws/d/dohwh/en_us/floor-plan/accommodation/assets/dohwh-coolcorner-floorplan-5121.jpg',
    enableSmartCrop: true,
    dynamic: false,
    renditions: [
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '1200px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '992px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-clsc.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-clsc.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '577px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-clsc.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '576px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-sq.jpg',
        mediaQuery: 'max-width',
        height: 0,
      },
    ],
    damPath:
      '/content/dam/marriott-digital/wh/emea/hws/d/dohwh/en_us/floor-plan/accommodation/assets/dohwh-coolcorner-floorplan-5121.jpg',
  },
  ':type': 'mi-aem-ppv5-spa/components/content/services-carousel',
  spaCard: [],
  closeModalTitle: 'Close Dialog',
  fnBorderingURL: 'https://www.taptastego.com/NYCMQ?lang=eng-usa&utm_source=Property_Portal&utm_medium=&utm_campaign=',
  fnbOpenInNewTab: '_blank',
  foodBeverageCard: {
    dynamicMedia: {
      altText: 'tpasr-landing-0195',
      assetPath:
        'https://cache.marriott.com/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg',
      enableSmartCrop: true,
      dynamic: false,
      renditions: [
        {
          renditionPath:
            '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, /content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
          mediaValue: '1200px',
          width: 400,
          dynamic: false,
          damPath:
            '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, /content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
          mediaValue: '992px',
          width: 400,
          dynamic: false,
          damPath:
            '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, /content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
          mediaValue: '577px',
          width: 400,
          dynamic: false,
          damPath:
            '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/content/dam/marriott-renditions/TPASR/tpasr-landing-0195-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/TPASR/tpasr-landing-0195-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
          mediaValue: '576px',
          width: 400,
          dynamic: false,
          damPath: 'https://cache.marriott.com/content/dam/marriott-renditions/TPASR/tpasr-landing-0195-sq.jpg',
          mediaQuery: 'max-width',
          height: 0,
        },
      ],
      damPath:
        '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg',
    },
    foodBeverageCtaLink:
      'https://www.taptastego.com/NYCMQ?lang=eng-usa&utm_source=Property_Portal&utm_medium=&utm_campaign=',
    foodBeverageCtaLabel: 'Start an Order',
    foodBeverageDescription:
      "See what's available from our hotel restaurants. Browse our menus, and where available, place your order or schedule one for later.",
    foodBeverageTitle: 'Browse, Tap, Eat',
    foodBeverageCardLabel: 'Order Food & Beverage',
    foodBeverageImageSrc:
      '/content/dam/marriott-digital/br/us-canada/hws/t/tpasr/en_us/photo/unlimited/assets/tpasr-landing-0195.jpg',
  },
  diningCardLabel: 'Reservations',
  diningCtaLabel: 'Make a Reservation',
  heading: 'Enjoy the Perks',
  diningTitle: 'Dining Reservations',
  diningModalTitle: 'Select a Restaurant',
  golfCardList: [],
  golfFallbackImage: {
    altText: 'dohwh-coolcorner-floorplan-5121',
    assetPath:
      'https://cache.marriott.com/content/dam/marriott-digital/wh/emea/hws/d/dohwh/en_us/floor-plan/accommodation/assets/dohwh-coolcorner-floorplan-5121.jpg',
    enableSmartCrop: true,
    dynamic: false,
    renditions: [
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '1200px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '992px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-wide.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-clsc.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-clsc.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '577px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-hor-clsc.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=400px:*, https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-sq.jpg?output-quality=70&interpolation=progressive-bilinear&downsize=800px:* 2x',
        mediaValue: '576px',
        width: 400,
        dynamic: false,
        damPath:
          'https://cache.marriott.com/content/dam/marriott-renditions/DOHWH/dohwh-coolcorner-floorplan-5121-sq.jpg',
        mediaQuery: 'max-width',
        height: 0,
      },
    ],
    damPath:
      '/content/dam/marriott-digital/wh/emea/hws/d/dohwh/en_us/floor-plan/accommodation/assets/dohwh-coolcorner-floorplan-5121.jpg',
  },
  spaTitle: 'Spa Reservations',
  fnbTitle: 'Order Food / Beverage',
  spaCardLabel: 'Reserve a Massage',
  golfReservationURL: '',
  hasCards: false,
  spaCtaLabel: 'Book a Spa Treatment',
  campaignsParams: {
    param1Value: 'marriott-property-portal',
    param2Value: 'ot_campaign',
    param1: 'ot_source',
    param2: 'marriott-property-portalv5',
    outletList: '123963,5489796,6815925,6813784,6490225',
  },
  golfCardLabel: 'Golf',
  golfTitle: 'Golf Reservations',
  epicgolfCardList: [],
};

export const localServicesMockUXL = {
  data: {
    property: {
      restaurants: {
        edges: [
          {
            node: {
              description:
                'Savor fresh, locally sourced food on-the-go or from the comfort of your room with our private dining menu in Times Square. All orders include eco-friendly utensils, napkins, and cups. Dial 1 from your room phone to place your order.',
              name: 'In-Room Dining',
              onProperty: true,
              reservationURL: null,
              media: {
                imageConnection: {
                  edges: [
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/mc-nycmq-levain-treat-40016:Classic-Hor',
                          square: '/is/image/marriotts7prod/mc-nycmq-levain-treat-40016:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'LeVain Sundae with ice cream, cookie, lit candle',
                        isPrimaryServices: true,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                  ],
                  __typename: 'ProductImageConnection',
                },
                __typename: 'ProductMedia',
              },
              productId: '5900776',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Bond 45 has a wide-ranging Italian menu including steak, seafood & an antipasti bar served in a sprawling space in the heart of the theater district.',
              name: 'Bond 45',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '6087094',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Settle into the heart of Times Square and experience our redesigned Broadway Lounge. Our quintessential New York restaurant serves up dining at Times Square with floor-to-ceiling views, classic cocktails, and contagious energy.',
              name: 'Broadway Lounge MMF TEST',
              onProperty: true,
              reservationURL: 'http://www.opentable.com/restaurant/profile/1221586/reserve?restref=1221586',
              media: {
                imageConnection: {
                  edges: [
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-broadway-lounge-2360:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-broadway-lounge-2360:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Broadway Lounge',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-broadway-lounge-6077:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-broadway-lounge-6077:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Broadway Lounge - Perch Terrace North',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                  ],
                  __typename: 'ProductImageConnection',
                },
                __typename: 'ProductMedia',
              },
              productId: '6669111',
              operationalDetails: {
                restaurantSoftware: 'OpenTable',
                restaurantSoftwareId: '1221586',
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Nestled eight floors above the heart of Times Square, enjoy exciting views of NYC from our newly redesigned modern outdoor terraces. Perch does not currently take reservations.',
              name: 'Perch Outdoor Terraces',
              onProperty: true,
              reservationURL: null,
              media: {
                imageConnection: {
                  edges: [
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: null,
                          square: null,
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Broadway Lounge - Perch Terrace South',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-broadway-lounge-6076:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-broadway-lounge-6076:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Broadway Lounge - Perch Terrace South',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                  ],
                  __typename: 'ProductImageConnection',
                },
                __typename: 'ProductMedia',
              },
              productId: '6798199',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description: "Bistro for dry-aged steaks & other French fare, with a bar that's strong on absinthe.",
              name: 'Boucherie Union Square',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '6839447',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description: 'No-frills counter-serve establishment serving New York-style slices & pies since 1975.',
              name: "Joe's Pizza",
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '6839460',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Featuring breathtaking panoramic views of Times Square, Executive Chef John Hayes has created a Contemporary American Grill. The restaurant is the perfect location for pre and post theater dining.',
              name: 'R Lounge at Two Times Square',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '125817',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Balthazar serves traditional bistro fare from breakfast through late-night supper. Opened by Keith McNally in the spring of 1997, Balthazar offers a French menu prepared by chefs de cuisine Riad Nasr and Lee Hanson.',
              name: 'Balthazar',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '110289',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Since the 1950’s, Junior’s has been famous for great food, great fun, great service and of course the best cheesecake in town.',
              name: 'Junior’s – Deli /American',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '110292',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Located on New York’s famed Restaurant Row in the heart of the theater district, Becco is open 7 days a week for both lunch & dinner.',
              name: 'Becco',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '110293',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Famous circa-1929 Village pizzeria slings trademark thin-crust pies in a soaring Midtown space.',
              name: "John's Pizzeria",
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '71637',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Del Frisco’s of New York is an energetic, sprawling, three-story restaurant located in the heart of Mid-town Manhattan.',
              name: 'Del Frisco’s Double Eagle Steak House',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '71635',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'BLT Steak is our interpretation of the American Steakhouse and combines bistro ambiance with steakhouse fare.',
              name: 'BLT Steak',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '110286',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                "Located on the Ground Floor Level of the hotel building, re-energize during your stay on Broadway with a visit to Starbucks®. Get your favorite beverage along with the coffee house's well-known pastries, breakfast foods and more.",
              name: 'Starbucks®',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '7060170',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Familiar, comforting, and sneakily sophisticated, our new Times Square restaurant, Revel & Rye offers up an intimate dining experience tucked away from the hustle and bustle of Broadway.',
              name: 'Revel & Rye Bar and Restaurant',
              onProperty: true,
              reservationURL: 'http://www.opentable.com/restaurant/profile/1221583/reserve?restref=1221583',
              media: {
                imageConnection: {
                  edges: [
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-revel-rye-2363:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-revel-rye-2363:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Revel & Rye Bar & Restaurant',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: null,
                          square: null,
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Revel & Rye Bar & Restaurant',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-revel-rye-2357:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-revel-rye-2357:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Revel & Rye - Atrium Dining',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-revel-rye-2363:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-revel-rye-2363:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Revel & Rye Bar & Restaurant',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                  ],
                  __typename: 'ProductImageConnection',
                },
                __typename: 'ProductMedia',
              },
              productId: '6792365',
              operationalDetails: {
                restaurantSoftware: 'OpenTable',
                restaurantSoftwareId: '1221583',
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'The city’s only revolving restaurant located on the 47th and 48th floors of the hotel offers American supper club fare, nightly live music, and 360-degree skyline views. Access to The View is on the 3rd floor.',
              name: 'The View Restaurant, Bar and Lounge',
              onProperty: true,
              reservationURL: 'https://www.sevenrooms.com/reservations/theviewny?default_date=2025-02-12',
              media: {
                imageConnection: {
                  edges: [
                    {
                      node: {
                        imageUrls: {
                          classicHorizontal: '/is/image/marriotts7prod/nycmq-broadway-lounge-6077:Classic-Hor',
                          square: '/is/image/marriotts7prod/nycmq-broadway-lounge-6077:Square',
                          __typename: 'ImageRendition',
                        },
                        alternateDescription: 'Broadway Lounge - Perch Terrace North',
                        isPrimaryServices: false,
                        defaultImage: false,
                        __typename: 'ProductImage',
                      },
                      __typename: 'ProductImageConnectionEdge',
                    },
                  ],
                  __typename: 'ProductImageConnection',
                },
                __typename: 'ProductMedia',
              },
              productId: '7194804',
              operationalDetails: {
                restaurantSoftware: null,
                restaurantSoftwareId: null,
                __typename: 'RestaurantOperationalDetails',
              },
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
          {
            node: {
              description:
                'Planet Hollywood Times Square is a vibrant, movie-themed restaurant featuring Hollywood memorabilia, classic American fare, and a lively atmosphere in the heart of NYC.',
              name: 'Planet Hollywood',
              onProperty: false,
              reservationURL: null,
              media: {
                imageConnection: null,
                __typename: 'ProductMedia',
              },
              productId: '7228442',
              operationalDetails: null,
              __typename: 'Restaurant',
            },
            __typename: 'RestaurantEdge',
          },
        ],
        __typename: 'RestaurantConnection',
      },
      spa: {
        edges: [
          {
            node: {
              name: 'Spa 2',
              description: null,
              bookNowURL: null,
              id: 'nycmq.7190224',
              onProperty: false,
              __typename: 'PropertySpa',
            },
            __typename: 'PropertySpaEdge',
          },
          {
            node: {
              name: 'Spa 3',
              description: null,
              bookNowURL: null,
              id: 'nycmq.7190225',
              onProperty: true,
              __typename: 'PropertySpa',
            },
            __typename: 'PropertySpaEdge',
          },
          {
            node: {
              name: 'Spa 4',
              description: null,
              bookNowURL: null,
              id: 'nycmq.7190226',
              onProperty: false,
              __typename: 'PropertySpa',
            },
            __typename: 'PropertySpaEdge',
          },
          {
            node: {
              name: 'Spa 6',
              description: null,
              bookNowURL: null,
              id: 'nycmq.7190228',
              onProperty: false,
              __typename: 'PropertySpa',
            },
            __typename: 'PropertySpaEdge',
          },
        ],
        __typename: 'PropertySpaConnection',
      },
      basicInformation: {
        isOrderFoodAndBeverageByMobileSupported: true,
        __typename: 'HotelBasicInformation',
      },
      media: {
        photoGallery: {
          spa: null,
          __typename: 'PhotoGalleryImageConnection',
        },
        __typename: 'HotelMediaContent',
      },
      __typename: 'Hotel',
    },
  },
};

export const localServicesMockUXLStorybook = {
  property: {
    restaurants: {
      edges: [
        {
          node: {
            description:
              'Sample Bavarian cuisine served by our friendly staff, dressed in traditional dirndl and lederhose, amidst a traditional ambiance. Enjoy a cold draught beer in Munich, Germany, in the attached beer garden, charmingly laid out with large chestnut trees.',
            name: "Paulaner's Wirtshaus & Beer Garden",
            onProperty: true,
            reservationURL: "https://www.tableresmarriott.com/paulaner's-restaurant-munich",
            productId: '6029906',
          },
        },
        {
          node: {
            description:
              "Munich's Greenhouse Restaurant offers a large, international breakfast, giving you the energy you need to start your day. Enjoy a variety of healthy dishes, along with classics such as pancakes and local specialties. The breakfast is 32€ per person.",
            name: 'Greenhouse Restaurant & Eventlocation',
            onProperty: true,
            reservationURL: null,
            productId: '6029907',
          },
        },
        {
          node: {
            description:
              'Make The Drop Botanical Bar & Eatery your all-day hotspot for homemade pastries, barista-quality coffees, healthy bowls, expertly mixed cocktails and revitalizing juices from Westin Fresh by The Juicery.',
            name: 'The Drop - Botanical Bar & Eatery',
            onProperty: true,
            reservationURL: null,
            productId: '6482848',
          },
        },
        {
          node: {
            description:
              'Rediscover the Bavarian cuisine and enjoy the flair of Munich at Schwarzreiter Tagesbar & Restaurant.',
            name: 'Schwarzreiter Tagesbar & Restaurant',
            onProperty: false,
            reservationURL: null,
            productId: '6496947',
          },
        },
        {
          node: {
            description:
              'Ristorante Cupido is an Italian gourmet restaurant in Munich. Enjoy fine Italian food and wines.',
            name: 'Ristorante Cupido',
            onProperty: false,
            reservationURL: null,
            productId: '6496948',
          },
        },
        {
          node: {
            description:
              'Experience exquisite fine French dining at Restaurant Atelier Gourmet. Our set menu is beautifully prepared, and you can choose from three, four or five course meals.',
            name: 'Restaurant Atelier Gourmet',
            onProperty: false,
            reservationURL: null,
            productId: '6498253',
          },
        },
        {
          node: {
            description:
              'Bring the whole family to visit little Italy in the heart of Munich! Enjoy pizza, pasta and other delicious Italian recipes.',
            name: 'Il Sogno',
            onProperty: false,
            reservationURL: null,
            productId: '6498254',
          },
        },
        {
          node: {
            description: 'The first Malaysian restaurant in Germany',
            name: 'Champor',
            onProperty: false,
            reservationURL: 'https://www.champor.de',
            productId: '6585764',
          },
        },
      ],
    },
    spa: {
      edges: [
        {
          node: {
            name: 'SAI SPA Munchen',
            description:
              'SAI SPA focuses on a classic selection of excellent massages from Europe and Asia, whose origins have been handed down for generations. All treatments are aimed at relaxing the body and allowing guests a moment of rest.',
            bookNowURL: null,
            id: 'mucwi.6497142',
            onProperty: false,
          },
        },
        {
          node: {
            name: 'ISARspa',
            description:
              'Inspired by the recreational value of the ISAR with its quiet natural reserves you will find your perfect personal time-out here.Please note kids are only allowed in the spa until 06:00pm.',
            bookNowURL: null,
            id: 'mucwi.6029909',
            onProperty: true,
          },
        },
        {
          node: {
            name: 'Medius Spa and Fitness at Four Points by Sheraton Munich Arabellapark',
            description:
              'Experience wellness and fitness from a completely new perspective at your Spa Hotel in Munich. Our 800m² large wellness area, including pool, sauna and spa awaits you on the 22nd and 23rd floor. Enjoy the unique view over the rooftops of Munich.',
            bookNowURL: null,
            id: 'mucwi.6710854',
            onProperty: false,
          },
        },
      ],
    },
    basicInformation: {
      isOrderFoodAndBeverageByMobileSupported: true,
    },
  },
};
